import React, { useState, useEffect, useRef } from "react";
import { styled } from "@mui/material/styles";
import { makeStyles, Button, Grid } from "@material-ui/core";
import Typography from "@mui/material/Typography";

import { getLabelDetail } from "../../actions/subscribe";

import closeSvg from "../../assets/svg/delete.svg";

const useStyles = makeStyles({
  box: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: (width) => {
      return width + "px";
    },
    background: "#fff",
    boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.2)",
    borderRadius: "4px",
  },
  title: {
    width: "100%",
    height: "48px",
    padding: "0 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #e9e9e9",
    fontSize: "14px !important",
    color: "#666",
    boxSizing: "border-box",
    "& img": {
      cursor: "pointer",
    },
  },
  content: {
    width: "100%",
    padding: "18px 8px 45px 66px",
    boxSizing: "border-box",
  },
  inputGroup: {
    position: "relative",
    display: "flex",
  },
  searchList: {
    position: "absolute",
    top: "42px",
    background: "#fff",
    minWidth: "300px",
    maxHeight: "300px",
    overflow: "auto",
    boxSizing: "border-box",
    border: "1px solid #d9d9d9",
    "& p": {
      height: "40px",
      lineHeight: "40px",
      padding: "0 10px",
      cursor: "pointer",
      "&:hover": {
        background: "#f1f1f1",
      },
    },
  },
  input: {
    width: "300px",
    height: "40px",
    padding: "0 15px",
    border: "1px solid #d9d9d9",
    fontSize: "16px",
    color: "#000",
    boxSizing: "border-box",
    borderRadius: "2px",
    outline: "none",
    "&::-webkit-input-placeholder": {
      color: "rgba(0, 0, 0, .25)",
    },
  },
  btn: {
    width: "70px",
    height: "40px",
    marginLeft: "14px",
    borderRadius: "2px",
    background: "#3276C3",
  },
  tagBox: {
    height: "114px",
    marginTop: "17px",
    paddingRight: "40px",
    overflow: "auto",
  },
  tag: {
    height: "28px",
    padding: "0 10px 0 16px",
    margin: "0 13px 15px 0",
    display: "inline-block",
    background: "#F3F3F3",
    color: "#666",
    fontSize: "14px",
    lineHeight: "28px",
    "& img": {
      marginLeft: "6px",
      cursor: "pointer",
    },
  },
  editInput: {
    display: "inline-block",
    height: "26px",
    width: "124px",
    margin: "0 13px 15px 0",
    padding: "0 12px",
    border: "1px solid #d9d9d9",
    outline: "none",
    borderRadius: 0,
    padding: "0 6px",
  },
});
export default function LabelModal(props) {
  const { width, title, close, tagArr, handRemove, handAdd, handEdit, isEdit, parent_lable_id } =
    props;
  const classes = useStyles(width);
  const [tagList, setTagList] = useState([]);
  const [tag, setTag] = useState("");
  const [label, setLabel] = useState("");
  const [timer, setTimer] = useState("");
  const [fnIndex, setFnIndex] = useState(0);
  const [tagSearhList, setTagSearhList] = useState([]);
  const [tagSearhShow, setTagSearhShow] = useState(false);

  useEffect(() => {
    setTagList([].concat(tagArr));
    console.log(12345, parent_lable_id)
  }, [tagArr]);

  const inputRef = useRef();

  const onChange = (e) => {
    setTag(e.target.value);
    handSearch(e.target.value, fnIndex + 1);
    setFnIndex(fnIndex + 1);
  };
  const handAddTag = () => {
    if (tag) {
      handAdd(tag);
      setTag("");
      setTagSearhShow(false);
    }
  };

  const handSearch = (tag, index) => {
    //防止多个请求
    clearTimeout(timer);
    let newTimer = setTimeout(() => {
      //发送请求
      doSearch(tag);
    }, 300);
    setTimer(newTimer);
  };
  const doSearch = (tag) => {
    console.log(123, tag, parent_lable_id)
    if (tag) {
      getLabelDetail({
        page: 1,
        pageSize: 999,
        lable_content__icontains: tag,
        parent_lable_id: parent_lable_id
      }).then((res) => {
        if (res.results && res.results.length) {
          setTagSearhList(
            res.results.filter((lable) => {
              return lable.lable_content.length < 20;
            })
          );
          setTagSearhShow(true);
        } else {
          setTagSearhList([]);
          setTagSearhShow(false);
        }
      });
    } else {
      setTagSearhList([]);
      setTagSearhShow(false);
    }
  };

  const handDblclick = (data, i) => {
    if (isEdit) {
      let list = [].concat(tagList);
      list.forEach((v) => {
        v.showInput = false;
      });
      list[i].showInput = true;
      setTagList([].concat(list));
      setLabel(list[i].lable_content);
      setTimeout(() => {
        document.querySelector("#labelInput").focus();
      }, 300);
    }
  };

  const changeLabel = (e) => {
    setLabel(e.target.value);
  };
  const editLabel = (tag, i, id) => {
    let list = [].concat(tagList);
    list[i].showInput = false;
    list[i].lable_content = label;
    setTagList([].concat(list));
    if (tag !== label) {
      //有修改
      handEdit(label, id);
    }
  };
  const chooseLabel = (tag) => {
    setTag(tag);
    setTagSearhShow(false);
  };

  return (
    <div className={classes.box}>
      <Typography className={classes.title}>
        <Typography variant="span">{title}</Typography>
        <Typography variant="span" onClick={() => close()}>
          <img src={closeSvg} />
        </Typography>
      </Typography>

      <div className={classes.content}>
        <div className={classes.inputGroup}>
          <input
            value={tag}
            onChange={onChange}
            type="text"
            className={classes.input}
            placeholder="标签"
          />
          <Button
            onClick={handAddTag}
            className={classes.btn}
            variant="contained"
            color="primary"
          >
            添加
          </Button>
          {tagSearhShow && (
            <div className={classes.searchList}>
              {tagSearhList.map((item) => {
                return (
                  <Typography
                    key={item.lable_content}
                    onClick={() => chooseLabel(item.lable_content)}
                  >
                    {item.lable_content}
                  </Typography>
                );
              })}
            </div>
          )}
        </div>

        <div className={classes.tagBox}>
          {tagList.length > 0 &&
            tagList.map((item, i) => {
              return item.showInput ? (
                <input
                  id="labelInput"
                  ref={inputRef}
                  key={`${item.lable_content}-input`}
                  onBlur={() => editLabel(item.lable_content, i, item.lable_id)}
                  className={classes.editInput}
                  type="text"
                  value={label}
                  onChange={changeLabel}
                />
              ) : (
                <div className={classes.tag} key={item.lable_content}>
                  {/* <div className={classes.tag} key={item.lable_content} onDoubleClick={() => handDblclick(item, i)}> */}
                  {item.lable_content}
                  <img
                    src={closeSvg}
                    onClick={() => handRemove(item.lable_id)}
                  />
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}
